import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<label class={{unless @classless \"tpk-radio-label\"}} for={{@guid}} ...attributes>\n  {{#if (has-block)}}\n    {{yield}}\n  {{else}}\n    {{@label}}\n  {{/if}}\n</label>\n", {
  moduleName: "@triptyk/ember-input/components/tpk-radio/label.hbs"
});